import { render, staticRenderFns } from "./other-documents.vue?vue&type=template&id=05534aaf"
import script from "./other-documents.vue?vue&type=script&lang=js"
export * from "./other-documents.vue?vue&type=script&lang=js"
import style0 from "./other-documents.vue?vue&type=style&index=0&id=05534aaf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports